import React from 'react';

import { css } from '@emotion/react';
import { CssVars, mediaQueryForExperimentalLayoutSizeMDOrSmaller } from '@robinhood/design';

import GradientBackground from 'src/components/creditApplication/GradientBackground';
import { CREDIT_APPLICATION_PAGE_MAX_WIDTH } from 'src/components/creditApplication/constants/dimensions';

interface PropsIface {
  maxContentWidth?: number;
}

const GradientBackgroundLayout = ({ children, maxContentWidth }: React.PropsWithChildren<PropsIface>) => {
  const contentContainerStyle = React.useMemo(() => {
    return css`
      max-width: ${maxContentWidth ?? CREDIT_APPLICATION_PAGE_MAX_WIDTH}px;
    `;
  }, [maxContentWidth]);

  return (
    <div css={root}>
      <GradientBackground>
        <div css={[page, contentContainerStyle]}>{children}</div>
      </GradientBackground>
    </div>
  );
};

const root = css`
  width: 100vw;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${CssVars.neutral.bg1};
`;

const page = css`
  margin: auto;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  padding-top: calc(120px + env(safe-area-inset-top));
  padding-left: 44px;
  padding-right: 44px;
  padding-bottom: 44px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    padding-top: calc(44px + env(safe-area-inset-top));
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
  }
`;

export default GradientBackgroundLayout;
